// extracted by mini-css-extract-plugin
module.exports = {"main":"RssFeed_main__3nlsA","header":"RssFeed_header__3hNB6","button":"RssFeed_button__4Gvkl","error":"RssFeed_error__mAdGl","field":"RssFeed_field__GZm3A"};